import { useState } from 'react'
import { RequestService, STATUSES } from '../services/RequestService'
import useSnackbar from './useSnackbar'

const STATUS = {
  PENDING: 'pending',
  ACKNOWLEDGED: 'acknowledged',
  COMPLETED: 'completed',
}

const useRecommendation = () => {
  const [loading, setLoading] = useState(false)
  const { errorSnackbar } = useSnackbar()

  const updateRecommendation = async ({ id, recommendationStatus }) => {
    setLoading(true)

    const ids = Array.isArray(id) ? id : [id]
    const responses = await Promise.all(
      ids.map(recommendationId =>
        RequestService.updateRecommendation({
          id: recommendationId,
          recommendationStatus,
        }),
      ),
    )
    const failedResponse = responses.find(
      response => response.status !== STATUSES.SUCCESS,
    )

    if (!failedResponse) {
      window.location.reload()
    } else {
      errorSnackbar({ text: failedResponse.data.message })
    }

    setLoading(false)
  }

  return { loading, STATUS, updateRecommendation }
}

export default useRecommendation
